"use strict";
var concat_1 = require('../operator/concat');
exports.concat = concat_1.concatStatic;
//# sourceMappingURL=concat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/concat.js
// module id = 152
// module chunks = 1